// onboarding.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PopoverController } from '@ionic/angular';
import { OnboardingPopoverComponent } from '../components/onboarding-popover/onboarding-popover.component';

export interface WalkthroughStep {
  attachTo: string;
  content: string;
  title?: string;
  avatar?: string;
  routeAction?: string;
  buttonText?: string;
  customerType?: "enterprise" | "newCustomer" | "trial" | "all" | "free";
  placement?: 'top' | 'right' | 'bottom' | 'left';
  // Extra property for resource links
  resources?: {
    label: string;
    url: string;
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {


  customerType = "enterprise";

  constructor(
    private popoverController: PopoverController
  ) {}

  public async startWalkthrough(steps: WalkthroughStep[], customerType): Promise<void> {
    console.log("Starting onboarding walkthrough...");
    console.log(steps);
    for (let i = 0; i < steps.length; i++) {

      // if customerType is not in the list of customerType, skip the step
      if (steps[i].customerType && steps[i].customerType !== "all" && steps[i].customerType !== customerType) {
        continue;
      }

      const step = steps[i];
      const isLast = i === steps.length - 1;

      // 1. Find the target element in the DOM
      const targetEl = document.querySelector(step.attachTo) as HTMLElement;
      if (!targetEl) {
        console.warn(`OnboardingService: Cannot find element for selector: ${step.attachTo}`);
        continue; // skip this step if element not found
      }

      const rect = targetEl.getBoundingClientRect();

      // 2. Create the Ionic Popover
      const popover = await this.popoverController.create({
        component: OnboardingPopoverComponent,
        cssClass: 'walkthrough-popover-class',
        componentProps: {
          step,
          isLast,
          rect,
        },
        // event: {
        //   // clientX: rect.left + rect.width / 2,
        //   // clientY: rect.top + rect.height / 2
        // },
        backdropDismiss: false // force user to tap "Next" or "Finish"
      });
      console.log("steps, step 1", steps, step);
      // 3. Present the popover
      await popover.present();
      console.log("steps, step 2", steps, step);

      // 4. Wait until the popover is dismissed before proceeding
      await popover.onDidDismiss();
      console.log("steps, step 3", steps, step);

    }

    console.log('Onboarding walkthrough completed!');
  }
}
